import {
  Directive,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
} from '@angular/core';
import { ConfirmationFacade, ConfirmationMetadata } from './state';
import { filter, withLatestFrom } from 'rxjs/operators';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Subject } from 'rxjs';

@UntilDestroy()
@Directive({
    selector: '[cashConfirmation]',
    standalone: true
})
export class ConfirmationDirective implements OnInit, OnDestroy {
  @Input() cashConfirmation: ConfirmationMetadata;
  @Input() bindOn: 'click' | 'onChange' = 'click';
  @Input() bindDisabled = true;
  @Input() host: any;

  @Output() confirmationChange = new EventEmitter<ConfirmationMetadata>();

  private isShowingConfirmation: Subject<boolean> = new Subject<boolean>();
  private dispose: () => void;

  constructor(
    private confirmationFacade: ConfirmationFacade,
    private element: ElementRef,
    private renderer: Renderer2,
  ) {}

  ngOnInit() {
    if (this.bindOn === 'onChange') {
      if (!this.host) {
        throw new Error('The host component should be informed when binding to onChange event');
      }
      this.host.onChange.subscribe(() => {
        // TODO: event.stopPropagation();
        this.showConfirmation();
      });
    } else {
      this.dispose = this.renderer.listen(this.element.nativeElement, this.bindOn, (event) => {
        event.stopPropagation();
        this.showConfirmation();
      });
    }

    if (this.confirmationChange?.observers.length > 0)
      this.confirmationFacade.last$
        .pipe(
          withLatestFrom(this.isShowingConfirmation),
          untilDestroyed(this),
          filter(
            ([last, isShowingConfirmation]) =>
              last?.key === this.cashConfirmation?.key && isShowingConfirmation,
          ),
        )
        .subscribe(([metadata]) => {
          this.confirmationChange.emit(metadata);
          this.isShowingConfirmation.next(false);
        });
  }

  private showConfirmation() {
    this.confirmationFacade.showConfirmation(this.cashConfirmation);
    this.isShowingConfirmation.next(true);
  }

  ngOnDestroy() {
    this.dispose?.();
  }
}
